import { render, staticRenderFns } from "./list.vue?vue&type=template&id=916de972&scoped=true"
import script from "./list.vue?vue&type=script&lang=js"
export * from "./list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "916de972",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Developer\\Projects\\new-lottery-assistant-qd\\mer_plat_admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('916de972')) {
      api.createRecord('916de972', component.options)
    } else {
      api.reload('916de972', component.options)
    }
    module.hot.accept("./list.vue?vue&type=template&id=916de972&scoped=true", function () {
      api.rerender('916de972', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/marketing/sign-challenge/list.vue"
export default component.exports